import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { IProfileQueryOptions } from "@temperature/_models/temperature/IProfileQueryOptions";
import { ITemperatureProfile } from "@temperature/_models/temperature/ITemperatureProfile";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class TemperatureProfileService {
    private temperatureProfilesCacheName: string = 'temperatureProfilesCache';
    constructor(private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService) { }

    getTemperatureProfiles(invalidateCache = false, queryOptions?: IProfileQueryOptions): Observable<ITemperatureProfile[]> {
        if (queryOptions) {
            return this.getTemperatureProfilesFromDb(queryOptions);
        }
        return this.dataCacheService.getOrRequest(this.temperatureProfilesCacheName, () => this.getTemperatureProfilesFromDb(), { invalidateCache });
    }

    getTemperatureProfilesFromDb(queryOptions?: IProfileQueryOptions): Observable<ITemperatureProfile[]> {
        const params = queryOptions ?? {};
        return this.http.get<ITemperatureProfile[]>('/api/temperature/profiles', { params: params });
    }

    saveTemperatureProfile(profile: ITemperatureProfile): Observable<ITemperatureProfile> {
        return this.http.post<ITemperatureProfile>('/api/temperature/profiles', { body: profile }).pipe(tap(profile => {
            this.dataCacheService.addOrUpdateItem(profile, this.temperatureProfilesCacheName)
        }))
    }
}
